import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  asProgramPageHeader: {
    padding: 0,
    display: "flex"
  },
  title: {
    color: colors.lightBlack,
    fontWeight: 600,
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0px",
    marginBottom: 0
  },
  container: {
    display: "flex",
    gap: "16px",
    margin: 0,
    padding: 0,
    maxWidth: "100%",
    color: colors.mediumGrey,
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24pX",
    "& svg": {
      minWidth: "36px",
      width: "36px",
      height: "44px"
    }
  },
  connected: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 12px",
    borderRadius: "16px",
    backgroundColor: colors.veryLightGreen,
    color: colors.lightgreen,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 500,
    width: "fit-content",
    height: "fit-content"
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "10px"
  }
}));

export default styles;